// import apis from '@/api'
import Wechat from '@/common/Wechat'
import { removeAuthInfo } from '@/components/medical-component-mobile/utils'
import { utils } from '@/components/medical-core'
import store from "@/store"
import Router from "@/router"
import RouterType from "@/router/RouterTypes"
import { PASCToast, PASCConfirm } from '@/components/Popups'
import i18n from "@/i18n"
import * as StoreType from "@/store/StoreTypes"
import Cons from "@/common/Constants"
import apis from "@/api"

export async function changePhone() {
    if (store.state.userInfo.channel === '5') { // 手机号登录
        removeAuthInfo();
        sessionStorage["enterUrl"] = location.href;
        Router.replace({
            name: RouterType.LOGIN
        })
        return;
    } else {
        await apis.uc.unbind();
    }

    removeAuthInfo();
    if (Wechat.isInWxApp()) {
        Wechat.redirectToChangePhone();
    } else {
        let url = utils.delUrlParam(window.location.href, 'code');
        location.replace(url);
    }
}

export function errorOrderTips(customerPhone) {
    PASCConfirm({
        title: '',
        allowHtml: true,
        closeOnPopstate: true,
        className: "order-error__tips",
        message: `${i18n.t('common.error_order')}<div class='phone-number'>${customerPhone}</div>`,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: String(i18n.t('common.call')),
        cancelButtonText: String(i18n.t('common.cancel')),
    }).then(res => {
        location.href = 'tel://' + customerPhone;
    });
}

export function goPay(orderInfo, nextRouter, isReplace = false) {
    // 主要参数存store
    let paySetting = {
        orderAmount: orderInfo.fee,
        outTime: orderInfo.outTime,
        orderTime: orderInfo.orderTime,
        saveTime: +new Date(),
        outTradeNo: orderInfo.orderNo || orderInfo.orderCode, // 订单号
        tenantId: store.state.hospital.currentHospital && store.state.hospital.currentHospital.tenantId,
        hospitalName: store.state.hospital.currentHospital && store.state.hospital.currentHospital.hospitalName,
        addDate: orderInfo.addDate,
    }
    store.commit(StoreType.MUTATION_PAY_SETTING, paySetting);
    store.dispatch(StoreType.ACTION_PAY, {
        nextRouter,
        query: {
            userId: store.state.userInfo.userId,
            orderCode: paySetting.outTradeNo,
            orderAmount: paySetting.orderAmount,
            businessType: '4',
            tenantId: paySetting.tenantId,
            hospitalName: paySetting.hospitalName,
            addDate: paySetting.addDate,
            outTime: paySetting.outTime,
        },
        callbackFn: () => {
            // 跳转小程序支付前展示弹框
            PASCConfirm({
                title: String(i18n.t('common.tips')),
                message: String(i18n.t('common.pay_back_tip')),
                showCancelButton: true,
                confirmButtonText: String(i18n.t('common.has_pay')),
                cancelButtonText: String(i18n.t('common.not_pay')),
                closeOnPopstate: true,
            }).then(() => {
                Router.replace({
                    name: nextRouter
                })
            })
        },
        isReplace
    })
}

export function siOrderCheck() {
    apis.ov.checkSpeedInquiryOrder().then(res => {
        if (res.data && res.data.orderStatus === 0) { // 待支付
            store.commit(StoreType.MUTATION_SI_TIPS_SHOW, true);
            store.commit(StoreType.MUTATION_SI_ORDER, res.data);
            return;
        }
        if (res.data && res.data.orderStatus === 1) { // 待接诊
            store.commit(StoreType.MUTATION_SI_ORDER, res.data);
            Router.push({
                name: RouterType.SPEED_INQUIRY_WAITING,
                query: {
                    useCache: '1',
                    orderCode: res.data.orderCode
                }
            });
            return;
        }

        if (store.getters[StoreType.PARAM_SPEED]["quickInquiryEnable"] === 0) {
            PASCToast(i18n.t('common.si_close')); // 极速咨询功能未开启
            return;
        }
        Router.push({
            name: RouterType.INTER_START_CONSULT,
            query: {
                inquiryType: Cons.SPEED_INQUIRY_TYPE
            }
        })
    })
}

export let patReplyFn = (function () {
    let map = {};
    return function (inqueryId) {
        if (!map[inqueryId]) {
            map[inqueryId] = 1;
            apis.ov.patReplyMsg({
                inqueryId
            })
        }
    }
})()

